import gql from "graphql-tag";
const IMAGES = gql`
	query (
		$where: PublicFileFilterInput
		$order: [PublicFileSortInput!]
		$skip: Int
		$take: Int
	) {
		images(where: $where, order: $order, skip: $skip, take: $take) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				name
				createdBy {
					id
					name
				}
				createdOn
			}
		}
	}
`;
const PUBLIC_FILES = gql`
	query (
		$where: PublicFileFilterInput
		$order: [PublicFileSortInput!]
		$skip: Int
		$take: Int
	) {
		publicFiles(where: $where, order: $order, skip: $skip, take: $take) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				name
				createdBy {
					id
					name
				}
				createdOn
				contentType
			}
		}
	}
`;
const VIDEOS = gql`
query (
	$where: VideoFileFilterInput
	$order: [VideoFileSortInput!]
	$skip: Int
	$take: Int
) {
	videos(where: $where, order: $order, skip: $skip, take: $take) {
		totalCount
		pageInfo {
			hasNextPage
		}
		items {
			id
			name
			path
			createdBy {
				id
				name
			}
			createdOn
		}
	}
}`;
const DELETE_PUBLIC_FILE = gql`
	mutation ($id: UUID!) {
		deletePublicFile(id: $id)
	}
`;
export {
  DELETE_PUBLIC_FILE,
  IMAGES,
  PUBLIC_FILES,
  VIDEOS
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
